module.exports = __webpack_public_path__ + "img/bg.5d6e8591.jpg";